export const doc_home_en = {
  title: "Piper docs",
  description: `Thanks for using Piper! Here you can find several documents that explain all the things you can do with this app. You can navigate through the docs using the index right below.
  
`
};
